import { HAS_CODING_CARDS_KEY, LAST_STEP_KEY, ONBOARDING_STATE, ONBOARDING_STEP_KEY } from "../core/constants";
import { getComponentData, setComponentData } from "../core/views";
import { getOnboardingData } from "./requests";

export const CARD_UNKNOWN = "UNKNOWN";
export const HAS_CARDS = "HAS_CARDS";
export const NO_CARDS = "NO_CARDS";
export const DISCARDED = "DISCARDED";

export async function loadOnboarding(path : string) {
  const data = await getOnboardingData(path);

  const currentStep = localStorage.getItem(ONBOARDING_STEP_KEY);
  const hasCodingCardsString = localStorage.getItem(HAS_CODING_CARDS_KEY);
  const finishedStep = localStorage.getItem(LAST_STEP_KEY);

  setComponentData(ONBOARDING_STATE, {
    currentStep : currentStep !== null ? parseInt(currentStep) : -1,
    hasCodingCards : hasCodingCardsString !== null ? hasCodingCardsString : CARD_UNKNOWN,
    lastFinishedStep : finishedStep !== null ? parseInt(finishedStep) : -1,
    data })    
}

export function dissmissOnboarding() {
  setCurrentOnboardingStep(-1);
}

export function setCurrentOnboardingStep(currentStep : number) {
  const onboardingData = getComponentData(ONBOARDING_STATE);
  const newOnboardingData = {
    ...onboardingData,
    currentStep
  }
  localStorage.setItem(ONBOARDING_STEP_KEY, currentStep.toString());
  setComponentData(ONBOARDING_STATE, newOnboardingData);
}

export function setCurrentJourneyFinished(currentStep : number) {
  const onboardingData = getComponentData(ONBOARDING_STATE);
  const newOnboardingData = {
    ...onboardingData,
    lastFinishedStep : currentStep
  }
  localStorage.setItem(LAST_STEP_KEY, currentStep.toString());
  setComponentData(ONBOARDING_STATE, newOnboardingData);
}

export function nextJourneyAvailable(currentView : string) {
  const onboardingData = getComponentData(ONBOARDING_STATE);
  if (onboardingData.currentStep > onboardingData.lastFinishedStep) {
    return false;
  }
  const nextMainStep = onboardingData.lastFinishedStep + 1
  const nextJourney = onboardingData.data?.journey?.find((elm) => elm.mainStep === nextMainStep);
  if (nextJourney && nextJourney.view === currentView) {
    return true;
  }
  return false;
}

export function getJourneySteps(currentStep : number, view : string) {
  const onboardingData = getComponentData(ONBOARDING_STATE);
  if (!currentStep || !onboardingData || !onboardingData.data) return [];
  if (onboardingData.data?.journey?.length > 0) {
    const journey = onboardingData.data?.journey?.find((elm) => elm.mainStep === currentStep);
    if (!journey || view !== journey.view) {
      return []
    }
    return convertStepsToJoyrideSteps(journey.steps);
  }
  return []
}

export function convertStepsToJoyrideSteps(steps: []) {
  const joyrideSteps = [];
  steps.forEach((step:{}, index) => {
    const joyrideStep = {

      ...step,
      content : getStepContent(step),
      target : getTarget(step),
      disableBeacon:true
    };
    joyrideSteps.push(joyrideStep)
  })
  return joyrideSteps;
}

function isHtml(text) {
  return /<\/?[a-z][\s\S]*>/i.test(text);
}

function getStepContent(step) {
  if (step.html) return (<div dangerouslySetInnerHTML={{__html:step.html}} />);
  else if (isHtml(step.content)) return (<div dangerouslySetInnerHTML={{__html:step.content}} />);
  else return step.content;
}

function getTarget(step) {
  if (step.selector) return step.selector;
  return step.target;
}

export function setHasCodingCards(hasCodingCards : string) {  
  const onboardingData = getComponentData(ONBOARDING_STATE);
  const newOnboardingData = {
    ...onboardingData,
    hasCodingCards: hasCodingCards
  }
  localStorage.setItem(HAS_CODING_CARDS_KEY, hasCodingCards);
  setComponentData(ONBOARDING_STATE, newOnboardingData);
}

export function getHasCodingCards() {
  const onboardingData = getComponentData(ONBOARDING_STATE);
  return onboardingData.hasCodingCards;
}
